import {Provider} from '@angular/core';

import {
  MyHistoryCreditUseCaseProvider
} from '@features/credit/presentation/providers/my-history-credit/my-history-credit.use-case.provider';

import {MyHistoryCreditFacade} from '@features/credit/presentation/facades/my-history-credit/my-history-credit.facade';

export const MyHistoryCreditFacadeProvider: Provider[] = [
    ...MyHistoryCreditUseCaseProvider,
  MyHistoryCreditFacade
];
